export default __webpack_public_path__ + "static/media/address-pc.44f55b22.jpg";